exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-autocomplete{width:100%}.p-autocomplete .p-inputtext{width:100%;font-size:14px!important;height:45px!important;padding:10px 15px!important;border-radius:2px!important;transition:.15s ease-in-out!important;font-weight:400!important;line-height:1.5!important;color:#495057!important;border:1px solid #ebebeb!important}.p-autocomplete .p-inputtext:hover{border-color:#ebebeb!important}.p-autocomplete .p-inputtext:focus{border-color:#f78c31!important;box-shadow:none!important}", ""]);

// exports
